export default __webpack_public_path__ + "static/media/Venturer's Straps of the Elder Bond.1785e5fc.jpg";